<section class="delete_content">
    
        <div class="avatar" [ngStyle]="{'background-color': contact.color}">
            <p>{{ contact.firstname.charAt(0) }}{{ contact.lastname.charAt(0) }}</p>
        </div>
        <h4>Are you sure you want to delete <strong>{{ contact.firstname }} {{ contact.lastname }}?</strong></h4>
            <div class="btn_container">
                <button class="cancel_btn" (click)="closeDialog()">
                    No
                    <img src="./assets/contact/Close.svg" alt="cancel">
                </button>

                <button class="create_btn" (click)="deleteItem()">
                    Yes
                    <img src="./assets/contact/check.svg" alt="Create">
                </button>
            </div>

</section>